import { create } from 'zustand';

export interface User {
  id: number;
  email: string;
  firstname: string;
  lastname: string;
  fullname: string;
  roles: string[];
  verified: boolean;
}

interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  setSession: (payload: { token: string; user: User }) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  isAuthenticated: false,
  setToken: (token) => set({ token, isAuthenticated: true }),
  setUser: (user) => set({ user }),
  setSession: ({ token, user }) => set({ token, user, isAuthenticated: true }),
  clear: () => set({ token: null, user: null, isAuthenticated: false }),
}));
